import { render, staticRenderFns } from "./HomeCalendar.vue?vue&type=template&id=70d8e26e&scoped=true&"
import script from "./HomeCalendar.vue?vue&type=script&lang=js&"
export * from "./HomeCalendar.vue?vue&type=script&lang=js&"
import style0 from "./HomeCalendar.vue?vue&type=style&index=0&id=70d8e26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8e26e",
  null
  
)

export default component.exports